import { gql } from '@apollo/client';

export const CREATE_HIERARCHY_GROUP_MUTATION = gql`
  mutation SalesWebCreateClarkeClient($input: CreateClarkeClientInput) {
    createClarkeClient(input: $input) {
      id
      name
      legalName
      docType
      docNumber
    }
  }
`;
